document.body.addEventListener('click', (e) => {
    const details = e.target.closest('details')
    if (details) {
        for (const el of document.querySelectorAll('details[open]')) {
            if (el !== details) el.open = false
        }
        if (!details.open) {
            setTimeout(() => {
                details.scrollIntoView({
                    block: 'start',
                    inline: 'nearest',
                    behavior: 'smooth',
                })
            }, 50)
        }
    }
})
